var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCoin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17.0 17.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375,0 L375,812 L0,812 L0,0 L375,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.49486856,0 C11.6342604,0 14.9898565,3.35559605 14.9898565,7.49486856 C14.9898565,11.6342604 11.6342604,14.9898565 7.49486856,14.9898565 C3.35559605,14.9898565 0,11.6342604 0,7.49486856 C0,3.35559605 3.35559605,0 7.49486856,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.49486856,0 C11.6275776,0 14.9898565,3.36227884 14.9898565,7.49486856 C14.9898565,11.6275776 11.6275776,14.9898565 7.49486856,14.9898565 C3.36227884,14.9898565 0,11.6275776 0,7.49486856 C0,3.36227884 3.36227884,0 7.49486856,0 Z M7.49486856,0.651691375 C3.72135947,0.651691375 0.651691375,3.72135947 0.651691375,7.49486856 C0.651691375,11.2683777 3.72135947,14.3380458 7.49486856,14.3380458 C11.2683777,14.3380458 14.3380458,11.2683777 14.3380458,7.49486856 C14.3380458,3.72135947 11.2683777,0.651691375 7.49486856,0.651691375 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.60688486,0 C3.68484278,0 4.56207834,0.87723556 4.56207834,1.95519348 L3.91038697,1.95519348 C3.91038697,1.23631619 3.32576215,0.651691375 2.60688486,0.651691375 L1.95519348,0.651691375 C1.23631619,0.651691375 0.651691375,1.23631619 0.651691375,1.95519348 L0.651691375,5.21388907 C0.651691375,5.93276636 1.23631619,6.51727182 1.95519348,6.51727182 L2.60688486,6.51727182 C3.32576215,6.51727182 3.91038697,5.93276636 3.91038697,5.21388907 L4.56207834,5.21388907 C4.56207834,6.291847 3.68484278,7.16908256 2.60688486,7.16908256 L1.95519348,7.16908256 C0.87723553,7.16908256 0,6.291847 0,5.21388907 L0,1.95519348 C0,0.87723556 0.87723553,0 1.95519348,0 L2.60688486,0 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-234.0 -438.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.0 401.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(215.0 30.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.0 7.999999999999972)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 14.9898565,0 14.9898565,14.9898565 0,14.9898565 0,0",
    stroke: "none",
    fill: "#FAC914"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i2)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 14.9898565,0 14.9898565,14.9898565 0,14.9898565 0,0",
    stroke: "none",
    fill: "#FBDF00"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.49486856,14.9898565 C3.36227884,14.9898565 0,11.6275776 0,7.49486856 C0,3.36227884 3.36227884,0 7.49486856,0 C11.6275776,0 14.9898565,3.36227884 14.9898565,7.49486856 C14.9898565,11.6275776 11.6275776,14.9898565 7.49486856,14.9898565 Z M7.49486856,0.651691375 C3.72135947,0.651691375 0.651691375,3.72135947 0.651691375,7.49486856 C0.651691375,11.2683777 3.72135947,14.3380458 7.49486856,14.3380458 C11.2683777,14.3380458 14.3380458,11.2683777 14.3380458,7.49486856 C14.3380458,3.72135947 11.2683777,0.651691375 7.49486856,0.651691375 Z",
    stroke: "#FBDF00",
    strokeWidth: 0.5,
    fill: "none",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.2138890733194785 3.9103869653768015)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i3)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 4.56207834,0 4.56207834,7.16908256 0,7.16908256 0,0",
    stroke: "none",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.95519348,7.16908256 C0.87723553,7.16908256 0,6.291847 0,5.21388907 L0,1.95519348 C0,0.87723556 0.87723553,0 1.95519348,0 L2.60688486,0 C3.68484278,0 4.56207834,0.87723556 4.56207834,1.95519348 L3.91038697,1.95519348 C3.91038697,1.23631619 3.32576215,0.651691375 2.60688486,0.651691375 L1.95519348,0.651691375 C1.23631619,0.651691375 0.651691375,1.23631619 0.651691375,1.95519348 L0.651691375,5.21388907 C0.651691375,5.93276636 1.23631619,6.51727182 1.95519348,6.51727182 L2.60688486,6.51727182 C3.32576215,6.51727182 3.91038697,5.93276636 3.91038697,5.21388907 L4.56207834,5.21388907 C4.56207834,6.291847 3.68484278,7.16908256 2.60688486,7.16908256 L1.95519348,7.16908256 Z",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    fill: "none",
    strokeMiterlimit: 10
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCoin);
export default __webpack_public_path__ + "static/media/icCoin.ffc199668f013c0a4eeb63319006dd58.svg";
export { ForwardRef as ReactComponent };